/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CurrentUserInfoResponse { 
    id: string;
    userName: string;
    email: string;
    isTwoFactorEnabled: boolean;
    isAuthenticatorEnabled: boolean;
    lastPasswordChangedDate: string;
    permissions?: Array<string> | null;
}

